export const getHoveredGridRow = state => state.grid.hoveredRow;

export default {
    getHoveredGridRow,
};
